module.exports = __webpack_public_path__ + "media/images/vacances-printemps-d-cfe5fe0c68e337854e309f1ad0084eb5.jpg";